import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  center: {
    width: '100%',
    margin: '0 auto',
    [theme.breakpoints.up('sm')]: {
      width: '80%',
    },
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },

  formControl: {
    width: '100%',
    margin: theme.spacing(1, 0.5, 2, 0),
    padding: theme.spacing(1, 1.5),
    border: `1px solid ${theme.palette.text.disabled}`,
    borderRadius: theme.spacing(0.5),
    fontFamily: 'Source Sans Pro',
  },

  submitWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },

  submit: {
    background: theme.palette.primary.main,
    borderRadius: theme.spacing(0.5),
    color: 'white',
    padding: theme.spacing(1.5, 2),
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightSemiBold,
    textTransform: 'uppercase',
    boxShadow: theme.shadows[0],
    border: 'none',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.body1.fontSize,
      '&:hover': {
        background: theme.palette.secondary.main,
      },
    },
  },

  labelClass: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.disabled,
  },

  errorMessage: {
    textAlign: 'center',
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.extras.red,
    marginTop: theme.spacing(2),
  },

  successMessage: {
    textAlign: 'center',
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
    marginTop: theme.spacing(2),
  },
}))
